/**

## Dialog Actions Button

*Extends [Sq Button](/components/glass/sq-button.html)*
This component is designed to be used in the context of the [dialog-actions](/components/glass/dialog-actions.html) component,
which is designed to be used in a dialog components [dialog-modal](/components/glass/dialog-modal.html),
[dialog-blade](/components/glass/dialog-blade.html) and [dialog-sheet](/components/glass/dialog-sheet.html).

### Parameters
@param {string} [context="MODAL"] The parent dialog context which this button is being called. Will be used to apply appropriate class names to the button

### Inherited from [Sq Button](/components/glass/sq-button.html)
@param {string} [rank="secondary"] The action hierarchy for this button. Will be used to apply appropriate class names to the button
@param {string} [type="button"] native button type. Defaults to "submit" when the rank is primary and "button" when it is secondary or null
@param {boolean} [disabled=false] Determines whether or not the button is disabled
@param {string} [label] If passed, this property will be used as the button text and the instance will be assumed non-block. You can forgo this property and the block form of the component will be treated as the button text
@param {boolean} [isShowingSpinner=false] Will ignore label or block text and show a loading spinner on the button
@param {string} [spinnerColor="blue-medium"] Specify the color for the slide on the spinner. Values are any svg-icon--theme color keyword
@param {string} [spinnerTrackColor="base"] Specify the color for the track on the spinner. Values are either 'base' or 'white'.
**/

import { computed } from '@ember/object';
import { equal } from '@ember/object/computed';
import { CONTEXT } from '../../utils/dialog-actions';
import SqButton, { BUTTON_RANK } from '../sq-button';
export default SqButton.extend({
  tagName: 'button',
  rank: null,
  classNames: ['dialog__button'],
  context: CONTEXT.MODAL,
  classNameBindings: ['dialogRankClass', 'contextClasses'],
  attributeBindings: ['isBlade:data-test-blade-button', 'modalButtonTestSelectorValue:data-test-modal-button', 'sheetButtonTestSelectorValue:data-test-sheet-button'],
  contextClasses: computed('context', 'rank', function () {
    switch (this.get('context')) {
      case CONTEXT.MODAL:
        if (this.get('rank') === BUTTON_RANK.PRIMARY) {
          return 'dialog--modal__button dialog__footer__button dialog--modal__button--primary';
        } else {
          return 'dialog--modal__button dialog__footer__button dialog--modal__button--secondary';
        }
      case CONTEXT.BLADE:
        return 'dialog__footer__button dialog--blade__footer__button';
      case CONTEXT.SHEET:
        if (this.get('rank') === BUTTON_RANK.PRIMARY) {
          return 'dialog--sheet__button dialog--sheet__button--primary';
        } else {
          return 'dialog--sheet__button dialog--sheet__button--secondary';
        }
      default:
        return '';
    }
  }),
  dialogRankClass: computed('rank', 'context', function () {
    if (this.get('rank') === BUTTON_RANK.PRIMARY) {
      return 'dialog__button--primary';
    } else if (this.get('rank') === BUTTON_RANK.SECONDARY) {
      return 'dialog__button--secondary';
    } else {
      return '';
    }
  }),
  // Test Selector Setup
  // Allows tests to target a data-test-selector according to
  // this button's context (e.g. [data-test-modal-button="primary"])
  isBlade: equal('context', CONTEXT.BLADE),
  modalButtonTestSelectorValue: computed('context', 'rank', function () {
    if (this.get('context') === CONTEXT.MODAL) {
      return this.get('rank');
    } else {
      return null;
    }
  }),
  sheetButtonTestSelectorValue: computed('context', 'rank', function () {
    if (this.get('context') === CONTEXT.SHEET) {
      return this.get('rank');
    } else {
      return null;
    }
  })
});